<div class="root">
  <div class="filter-bar" [ngbCollapse]="isFilterCollapsed">
    <div>
      <div>{{ 'label.Portfolio' | translate }}</div>
      <div>
        <select [(ngModel)]="filterPagingWrapper.portfolioId">
          <option selected></option>
          <option
            *ngFor="let item of accessiblePortfolios"
            [value]="item.portfolioId"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <div>{{ 'label.TransactionCode' | translate }}</div>
      <div>
        <input type="text" [(ngModel)]="filterPagingWrapper.transactionCode" />
      </div>
    </div>
    <div>
      <div>{{ 'label.InvoiceCode' | translate }}</div>
      <div>
        <input type="text" [(ngModel)]="filterPagingWrapper.invoiceCode" />
      </div>
    </div>
    <div>
      <div>{{ 'label.CustomerCredential' | translate }}</div>
      <div>
        <input
          type="text"
          [(ngModel)]="filterPagingWrapper.customerCredential"
        />
      </div>
    </div>
    <div *ngIf="hasManageAllTransactionsPermission">
      <div>{{ 'label.AccountManager' | translate }}</div>
      <div>
        <select
          [ngModel]="accountManagers && filterPagingWrapper.accountManagerId"
          (ngModelChange)="
            accountManagers && (filterPagingWrapper.accountManagerId = $event)
          "
        >
          <option selected></option>
          <option *ngFor="let item of accountManagers" [value]="item?.adminId">
            {{ item?.fullName }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <div>{{ 'label.PaymentType' | translate }}</div>
      <div>
        <select [(ngModel)]="filterPagingWrapper.paymentTypeId">
          <option selected></option>
          <option *ngFor="let item of paymentTypeValues" [value]="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <div>{{ 'label.ProductType' | translate }}</div>
      <div>
        <select [(ngModel)]="filterPagingWrapper.productTypeId">
          <option selected></option>
          <option *ngFor="let item of productTypeValues" [value]="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <p-checkbox
        [(ngModel)]="filterPagingWrapper.displayZeroInvoices"
        binary="true"
        inputId="chk-displayZeroInvoices"
      ></p-checkbox>
      <label for="chk-displayZeroInvoices">{{
        'label.DisplayZeroInvoices' | translate
      }}</label>
      <br /><br />
      <p-checkbox
        [(ngModel)]="filterPagingWrapper.displayRejectedAndCanceled"
        binary="true"
        inputId="chk-displayRejectedAndCanceled"
      ></p-checkbox>
      <label for="chk-displayRejectedAndCanceled">{{
        'label.DisplayRejectedAndCanceled' | translate
      }}</label>
      <br /><br />
      <p-checkbox
        [(ngModel)]="filterPagingWrapper.displayOnlyWithoutFinalApproval"
        binary="true"
        inputId="chk-displayOnlyWithoutFinalApproval"
      ></p-checkbox>
      <label for="chk-displayOnlyWithoutFinalApproval">{{
        'label.DisplayOnlyWithoutFinalApproval' | translate
      }}</label>
      <br /><br />
      <p-checkbox
        [(ngModel)]="
          filterPagingWrapper.displayOnlyWithoutInitialCompleteApproval
        "
        binary="true"
        inputId="chk-displayOnlyWithoutInitialCompleteApproval"
      ></p-checkbox>
      <label for="chk-displayOnlyWithoutInitialCompleteApproval">{{
        'label.DisplayOnlyWithoutInitialCompleteApproval' | translate
      }}</label>
      <br /><br />
    </div>
    <div class="c-date-picker">
      <div>{{ 'label.Dates' | translate }}:</div>
      <hr-date-range-picker
        class="date-picker"
        [dateFormat]="specialDateFormat"
        [style]="{ width: '100%', 'min-width': '5em' }"
        [(ngModel)]="filterPagingWrapper.createDate"
      ></hr-date-range-picker>
    </div>

    <div class="c-date-picker approval-date">
      <div>{{ 'label.ApprovalDate' | translate }}:</div>
      <hr-date-range-picker
        class="date-picker"
        [dateFormat]="specialDateFormat"
        [style]="{ width: '100%', 'min-width': '5em' }"
        [(ngModel)]="filterPagingWrapper.approveDate"
      ></hr-date-range-picker>
    </div>
    <div class="filter-actions">
      <p-button
        type="button"
        class="ui-button-secondary"
        (click)="onApplyFilter()"
        label="{{ 'label.Filter' | translate }}"
      ></p-button>
      <p-button
        type="button"
        class="ui-button-secondary"
        (click)="onClearFilter()"
        label="{{ 'label.Clear' | translate }}"
      ></p-button>
    </div>
  </div>
  <div id="separator" (click)="isFilterCollapsed = !isFilterCollapsed"></div>
  <div class="transactions-table">
    <div style="padding-bottom: 5px; display: flex">
      <p-button
        type="button"
        class="ui-button-secondary"
        (click)="onTransactionInitialApprove(true)"
        label="{{ 'label.ApproveTransactionPartial' | translate }}"
      ></p-button>
      <p-button
        type="button"
        class="ui-button-secondary"
        (click)="onTransactionInitialApprove(false)"
        label="{{ 'label.ApproveTransactionComplete' | translate }}"
      ></p-button>
      <p-button
        type="button"
        class="ui-button-secondary"
        (click)="onTransactionReject()"
        label="{{ 'label.RejectTransaction' | translate }}"
      ></p-button>
      <p-button
        type="button"
        class="ui-button-secondary"
        [disabled]="!isConfirmationAvailable()"
        (click)="onOrderConfirmationClick()"
        [ngStyle]="{ margin: '0 auto' }"
        icon="fa fa-envelope"
        label="{{ 'label.SendOrderConfirmationEmail' | translate }}"
      ></p-button>
      <p-button
        type="button"
        class="ui-button-secondary"
        [disabled]="!hasFinalApprovePermission"
        (click)="onTransactionFinalApprove()"
        [ngStyle]="{ float: 'right' }"
        label="{{ 'label.ApproveTransactionFinal' | translate }}"
      ></p-button>
    </div>
    <hr-transaction-edit
      [transaction]="editingTransaction"
      [display]="displayEdit"
      (onUpdate)="onTransactionEdit($event)"
    ></hr-transaction-edit>
    <hr-order-confirmation-dialog
      *ngIf="trySendOrderConfirmation"
      [transactions]="getSelectedTransactionIds()"
      (onUpdate)="onUpdateTable($event)"
    ></hr-order-confirmation-dialog>
    <p-table
      [responsive]="true"
      showGridlines
      [value]="transactions"
      [(selection)]="selectedTransactions"
      [lazy]="true"
      [paginator]="true"
      [rows]="pageSize"
      (onLazyLoad)="onLoad($event)"
      [totalRecords]="totalRecords"
      dataKey="transactionRecordId"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 5em">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>

          <th [pSortableColumn]="'transactionCode'" style="width: 130px">
            {{ 'label.TransactionCode' | translate }}
            <p-sortIcon
              [field]="'transactionCode'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'createDate'" style="width: 100px">
            {{ 'label.Date' | translate }}
            <p-sortIcon
              [field]="'createDate'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'customer'" style="width: 100px">
            {{ 'label.Customer' | translate }}
            <p-sortIcon
              [field]="'customer'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'payer'" style="width: 100px">
            {{ 'label.Payer' | translate }}
            <p-sortIcon
              [field]="'payer'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th style="width: 10%">
            {{ 'label.AccountManager' | translate }}
          </th>

          <th>
            {{ 'label.Product' | translate }}
          </th>

          <th [pSortableColumn]="'orderTotal'" style="width: 100px">
            {{ 'label.Total' | translate }}
            <p-sortIcon
              [field]="'orderTotal'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'discount'" style="width: 90px">
            {{ 'label.TransactionListDiscount' | translate }}
            <p-sortIcon
              [field]="'discount'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'invoiceTotal'" style="width: 160px">
            {{ 'label.InvoiceAmount' | translate }}
            <p-sortIcon
              [field]="'invoiceTotal'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th style="width: 30px">₾</th>

          <th [pSortableColumn]="'transactionStatusId'" style="width: 120px">
            {{ 'label.TransactionStatus' | translate }}
            <p-sortIcon
              [field]="'transactionStatusId'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th [pSortableColumn]="'approvalStatusId'" style="width: 90px">
            Ac. Man. Appr.
            <p-sortIcon
              [field]="'approvalStatusId'"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>

          <th style="width: 60px">Man. Appr.</th>

          <th style="width: 50px">&nbsp;</th>
        </tr>
      </ng-template>

      <ng-template
        pTemplate="body"
        let-transaction
        let-expanded="expanded"
        let-columns="columns"
      >
        <tr
          [pSelectableRow]="transaction"
          [ngClass]="getRowStyleClass(transaction)"
        >
          <td>
            <p-tableCheckbox [value]="transaction"></p-tableCheckbox>
          </td>
          <td>
            <span>{{ transaction.code }}</span
            ><br />
            <a
              *ngIf="transaction.proFormaInvoiceFileId"
              href="{{ transaction.proFormaInvoiceFileId }}"
              target="_blank"
              >{{ 'label.Proforma' | translate }}</a
            ><br />
            <span *ngIf="transaction.isProFormaInvoiceSent">{{
              'label.Sent' | translate
            }}</span>
          </td>
          <td>
            <div class="create-date">
              <span title="{{ transaction.createDate | date : 'shortTime' }}">{{
                transaction.createDate | date : dateFormat
              }}</span
              ><br />
              <i
                *ngIf="transaction.isConfirmationEmailSent"
                class="fa fa-envelope confirmation-sent"
                aria-hidden="true"
              ></i>
              <span class="create-date-tooltip">{{
                transaction.confirmationEmailSendDate | date : dateFormat
              }}</span>
            </div>
          </td>
          <td>
            <span
              ><a [routerLink]="['/customers/view', transaction?.customerId]">{{
                transaction.customerName
              }}</a></span
            ><br />
            <span style="color: #8c8c8c">{{ transaction.customerTaxId }}</span>
          </td>
          <td>
            <span
              ><a
                [routerLink]="['/customers/view', transaction.payerCustomerId]"
                >{{ transaction.payerName }}</a
              ></span
            ><br />
            <span style="color: #8c8c8c">{{ transaction.payerTaxId }}</span>
          </td>
          <td>
            <span>{{ transaction.salesCustomerPortfolioAccountManager }}</span
            ><br />
            <span style="color: #c0c0c0">{{
              transaction.announcementPublisher
            }}</span>
          </td>
          <td>
            <div *ngIf="!transaction.isStandalone"><span>UPGRADE</span></div>
            <span>{{ getProductNames(transaction) }}</span
            ><br />
            <span
              ><b>{{ transaction.announcementTitle }}</b></span
            >
          </td>

          <td>
            <span>{{ transaction.orderTotalAmount }}</span>
          </td>

          <td>
            <span>{{ transaction.discount }}%</span>
          </td>

          <td>
            <span>{{ transaction.invoiceTotalAmount }}</span>
          </td>

          <td>
            <i
              class="fa fa-university"
              aria-hidden="true"
              *ngIf="transaction.paymentMethodId == PaymentMethod.CreditPaid"
            ></i>
            <i
              class="fa fa-credit-card"
              aria-hidden="true"
              *ngIf="transaction.paymentMethodId == PaymentMethod.Prepaid"
            ></i>
            <i
              class="fa fa-exchange"
              aria-hidden="true"
              *ngIf="transaction.paymentMethodId == PaymentMethod.Barter"
            ></i>
            <i
              class="fa fa-home"
              aria-hidden="true"
              *ngIf="transaction.paymentMethodId == PaymentMethod.Internal"
            ></i>
          </td>

          <td>
            <span>{{ transaction.transactionStatusName }}</span>
          </td>

          <td>
            <div class="account-manager-approval-status approval-status">
              <i
                *ngIf="
                  transaction.approvalStatusId !=
                  TransactionApprovalStatus.NotApproved
                "
                class="fa fa-check-circle"
                [ngClass]="{
                  'final-approve-icon':
                    transaction.approvalStatusId ==
                      TransactionApprovalStatus.FinalApprove ||
                    transaction.approvalStatusId ==
                      TransactionApprovalStatus.InitialApproveComplete,
                  'partial-approve-icon':
                    transaction.approvalStatusId ==
                    TransactionApprovalStatus.InitialApprovePartial
                }"
                aria-hidden="true"
              ></i>
              <i
                *ngIf="
                  transaction.transactionStatusId == TransactionStatus.Rejected
                "
                class="fa fa-times-circle"
                aria-hidden="true"
              ></i>
              <div class="account-manager-approval-status-tooltip">
                <span>{{ transaction.approvalStatusName }}</span
                ><br />
                <span>{{
                  transaction.approveDate | date : hoverDateFormat
                }}</span
                ><br />
                <span>{{ getInitialApproveFullName(transaction) }}</span>
              </div>
            </div>
          </td>

          <td>
            <div class="final-approval-status approval-status">
              <i
                class="final-approve-icon fa fa-check-circle"
                aria-hidden="true"
                *ngIf="
                  transaction.approvalStatusId ==
                  TransactionApprovalStatus.FinalApprove
                "
              ></i>
              <div class="final-approval-status-tooltip">
                <span>{{ transaction.approvalStatusName }}</span
                ><br />
                <span>{{
                  transaction.finalApproveDate | date : hoverDateFormat
                }}</span
                ><br />
                <span>{{ transaction.finalApproveUserFullName }}</span>
              </div>
            </div>
          </td>

          <td>
            <div style="padding-bottom: 5px">
              <p-button
                type="button"
                (click)="onEditTransactionClick(transaction)"
                icon="fa fa-edit"
                [disabled]="
                  transaction.approvalStatusId ==
                    TransactionApprovalStatus.FinalApprove &&
                  !hasEditInvoicePermission
                "
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer" let-columns>
        <tr>
          <td>{{ totalRecords }}</td>
          <td colspan="6"></td>
          <td>{{ totalAmounts?.ordersTotal }}</td>
          <td></td>
          <td>{{ totalAmounts?.invoicesTotal }}</td>
          <td colspan="5"></td>
        </tr>
      </ng-template>

      <!-- <p-column [style]="{'width':'38px'}" selectionMode="multiple"></p-column>
            <p-column header="{{'label.TransactionCode' | translate}}" field="transactionCode" [sortable]="true" [style]="{'width':'90px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span>{{transaction.code}}</span><br>
                <a *ngIf="transaction.proFormaInvoiceFileId" href="{{transaction.proFormaInvoiceFileId}}" target="_blank">{{'Proforma' | translate}}</a><br>
                <span *ngIf="transaction.isProFormaInvoiceSent">{{'label.Sent' | translate}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Date' | translate}}" field="createDate" [sortable]="true" [style]="{'width':'90px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <div class="create-date">
                    <span title="{{transaction.createDate | date:'shortTime'}}">{{transaction.createDate | date:dateFormat}}</span><br>
                    <i *ngIf="transaction.isConfirmationEmailSent" class="fa fa-envelope confirmation-sent" aria-hidden="true"></i>
                    <span class="create-date-tooltip">{{transaction.confirmationEmailSendDate | date:dateFormat}}</span>
                </div>
            </ng-template>
            </p-column>
            <p-column header="{{label.'Customer' | translate}}" field="customer" [sortable]="true">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span><a [routerLink]="['/customers/view', transaction?.customerId]">{{transaction.customerName}}</a></span><br>
                <span style="color:#8c8c8c">{{transaction.customerTaxId}}</span>
            </ng-template>
            </p-column>
            <p-column header="{{'label.Payer' | translate}}" field="payer" [sortable]="true">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span><a [routerLink]="['/customers/view', transaction.payerCustomerId]">{{transaction.payerName}}</a></span><br>
                <span style="color:#8c8c8c">{{transaction.payerTaxId}}</span>
            </ng-template>
            </p-column>

            <p-column header="{{'label.AccountManager' | translate}}" [style]="{'width':'10%'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span>{{transaction.salesCustomerPortfolioAccountManager}}</span><br>
                <span style="color:#c0c0c0">{{transaction.announcementPublisher}}</span>
            </ng-template>
            </p-column>

            <p-column header="{{'label.Product' | translate}}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <div *ngIf="!transaction.isStandalone"><span>UPGRADE</span></div>
                <span>{{transaction.getProductNames()}}</span><br>
                <span><b>{{transaction.announcementTitle}}</b></span>
            </ng-template>
            </p-column>

            <p-column header="{{'label.Total' | translate}}" field="orderTotal" [sortable]="true" [style]="{'width':'50px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span>{{transaction.orderTotalAmount}}</span>
            </ng-template>
            </p-column>

            <p-column header="{{'label.TransactionListDiscount' | translate}}" field="discount" [sortable]="true" [style]="{'width':'45px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span>{{transaction.discount}}%</span>
            </ng-template>
            </p-column>

            <p-column header="{{'label.InvoiceAmount' | translate}}" field="invoiceTotal" [sortable]="true" [style]="{'width':'70px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span>{{transaction.invoiceTotalAmount}}</span>
            </ng-template>
            </p-column>

            <p-column header="₾" [style]="{'width':'30px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <i class="fa fa-university" aria-hidden="true" *ngIf="transaction.paymentMethodId == PaymentMethod.CreditPaid"></i>
                <i class="fa fa-credit-card" aria-hidden="true" *ngIf="transaction.paymentMethodId == PaymentMethod.Prepaid"></i>
                <i class="fa fa-exchange" aria-hidden="true" *ngIf="transaction.paymentMethodId == PaymentMethod.Barter"></i>
                <i class="fa fa-home" aria-hidden="true" *ngIf="transaction.paymentMethodId == PaymentMethod.Internal"></i>
            </ng-template>
            </p-column>

            <p-column header="{{'label.TransactionStatus' | translate}}" field="transactionStatusId" [sortable]="true" [style]="{'width':'100px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <span>{{transaction.transactionStatusName}}</span>
            </ng-template>
            </p-column>

            <p-column header="Ac. Man. Appr." field="approvalStatusId" [sortable]="true" [style]="{'width':'65px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <div class="account-manager-approval-status approval-status">
                    <i *ngIf="transaction.approvalStatusId != TransactionApprovalStatus.NotApproved" class="fa fa-check-circle" [ngClass]="{'final-approve-icon': transaction.approvalStatusId == TransactionApprovalStatus.FinalApprove
                        || transaction.approvalStatusId == TransactionApprovalStatus.InitialApproveComplete, 'partial-approve-icon': transaction.approvalStatusId == TransactionApprovalStatus.InitialApprovePartial}" aria-hidden="true"></i>
                    <i *ngIf="transaction.transactionStatusId == TransactionStatus.Rejected" class="fa fa-times-circle" aria-hidden="true"></i>
                    <div class="account-manager-approval-status-tooltip">
                        <span>{{transaction.approvalStatusName}}</span><br>
                        <span>{{transaction.approveDate | date:hoverDateFormat}}</span><br>
                        <span>{{transaction.getInitialApproveFullName()}}</span>
                    </div>
                </div>
            </ng-template>
            </p-column>
            <p-column header="Man. Appr." [style]="{'width':'40px'}">
            <ng-template let-col let-transaction="rowData" pTemplate="body">
                <div class="final-approval-status approval-status">
                    <i class="final-approve-icon fa fa-check-circle" aria-hidden="true" *ngIf="transaction.approvalStatusId == TransactionApprovalStatus.FinalApprove"></i>
                    <div class="final-approval-status-tooltip">
                        <span>{{transaction.approvalStatusName}}</span><br>
                        <span>{{transaction.finalApproveDate | date:hoverDateFormat}}</span><br>
                        <span>{{transaction.finalApproveUserFullName}}</span>
                    </div>
                </div>
            </ng-template>
            </p-column>


            <p-column [style]="{'width':'35px'}">
                <ng-template let-col let-transaction="rowData" pTemplate="body">
                <div style="padding-bottom: 5px;">
                    <p-button type="button" (click)="onEditTransactionClick(transaction)" icon="fa fa-edit" [disabled]="transaction.approvalStatusId == TransactionApprovalStatus.FinalApprove && !hasEditInvoicePermission"></p-button>
                </div>
            </ng-template>
            </p-column>

            <p-footerColumnGroup>
                <p-row>
                    <p-column footer="{{totalRecords}}"></p-column>
                    <p-column colspan="6"></p-column>
                    <p-column footer="{{totalAmounts?.ordersTotal}}"></p-column>
                    <p-column></p-column>
                    <p-column footer="{{totalAmounts?.invoicesTotal}}"></p-column>
                    <p-column colspan="5"></p-column>
                </p-row>
            </p-footerColumnGroup> -->

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="15">
            {{ 'message.NoRecordsFound' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
